<template>
    <el-row class="welcome-row">
        <el-row>
            <el-col :span="12" style="">
                <el-card class="box-card" style="height:760px">
                    <div slot="header" class="clearfix">
                        <span>公告</span>
                    </div>
                    <div>
                        <span>欢迎登录订单管理系统！</span>
                    </div>
                </el-card>
            </el-col>
            <el-col :span="12">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>日历</span>
                    </div>
                    <el-calendar v-model="value">
                    </el-calendar>
                </el-card>
            </el-col>
        </el-row>
    </el-row>
</template>

<script>

    export default {
        name:'Welcome',
        data() {
            return {
                user:{
                    userName:'',
                    password:''
                },
                imgList:[
                ],
                value: new Date()
                
            }
        },
        methods: {
        }
        
    }


</script>

<style scoped>


</style>
